export const dismissedDowntimeBannerStorageKey =
  'axle-dismissed-downtime-banner';
